

import { getData, postData } from './redux_data';
import {
    MODIFY_ARQUEO_CIERRE_SEMANAL, MODIFY_VARIACION_EUROS, MODIFY_VARIACION_TOKENS, MODIFY_VARIACION_TOKENS_CENTRO, MODIFY_MAQ_ARCADE_CIERRE_SEMANAL, RESET_CIERRE_SEMANAL_DATOS, MODIFY_BANCO_2_CIERRE_SEMANAL,
    MODIFY_FIELD_OTROSDATOS_CIERRE_SEMANAL, UPDATE_DATOS_CIERRE_SEMANAL, GET_RESUMEN_CIERRE_SEMANAL, DESBLOQUEAR_CIERRE_SEMANAL, CIERRE_SEMANAL_CERRAR_SEMANA, UPDATE_OTROS_DATOS_CIERRE_SEMANAL, UPDATE_BILLARES_CIERRE_SEMANAL
} from '../constants/action_types';

import {

    GET_CIERRE_SEMANAL_DATOS,
    GET_OTROS_DATOS_CIERRE_SEMANAL
} from '../constants/action_types';

export function getDatosCierreSemanal(centroid, date) {
    return getData('cierreSemanalDatos?centro_id=' + centroid + '&date=' + date, GET_CIERRE_SEMANAL_DATOS, {centroid, date});
}

export function resetDatosCierreSemanal() {
    return (dispatch, getState) => {
        dispatch({ type: RESET_CIERRE_SEMANAL_DATOS, payload: {} });
    }
}

export function getOtrosDatosCierreSemanal(centroid, date) {
    return getData('cierreSemanalOtrosDatos?centro_id=' + centroid + '&date=' + date, GET_OTROS_DATOS_CIERRE_SEMANAL);
};

export function getResumenCierreSemanal(centroid, date) {
    return getData('cierreSemanalResumen?centro_id=' + centroid + '&date=' + date, GET_RESUMEN_CIERRE_SEMANAL);
};


export function modifyArqueo(value) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_ARQUEO_CIERRE_SEMANAL, payload: value });
    }
}

export function modifyBanco2(value){
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_BANCO_2_CIERRE_SEMANAL, payload: value });
    }
}

export function modifyVariacionEuros(value) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_VARIACION_EUROS, payload: value });
    }
}

export function modifyVariacionTokensCentro(value) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_VARIACION_TOKENS_CENTRO, payload: value });
    }
};

export function modifyVariacionTokens(value) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_VARIACION_TOKENS, payload: value });
    }
}

export function modifyFieldOtrosDatosSemanal(field, value) {
    return dispatch => {
        dispatch({ type: MODIFY_FIELD_OTROSDATOS_CIERRE_SEMANAL, payload: { field, value } })
    };
};

export function modifyMaqArcade(zonaId, total_euros, total_euros_sin_mult, total_tickets, total_tokens, total_visas) {

    return (dispatch, getState) => {
        dispatch({ type: MODIFY_MAQ_ARCADE_CIERRE_SEMANAL, payload: { zonaId, total_euros, total_euros_sin_mult, total_tickets, total_tokens, total_visas } });
    }
}

export function updateCierreSemanalBillaresDB(centro_id, date, billares) {

    const postURL = `cierreSemanalDatos/Billares?centro_id=${centro_id}&date=${date}&billares=${billares}`;
    return postData(postURL, UPDATE_BILLARES_CIERRE_SEMANAL, {}, undefined, undefined);
};

export function updateCierreSemanalDatosDB(cierreSemanal, centro_id, date, thenHandler) {

    const postURL = `cierreSemanalDatos?centro_id=${centro_id}&date=${date}`;
    return postData(postURL, UPDATE_DATOS_CIERRE_SEMANAL, cierreSemanal, undefined, thenHandler);
};

export function updateCierreSemanalOtrosDatosDB(otrosDatos, centro_id, date, thenHandler) {

    const postURL = `cierreSemanalOtrosDatos?centro_id=${centro_id}&date=${date}`;
    return postData(postURL, UPDATE_OTROS_DATOS_CIERRE_SEMANAL, otrosDatos, undefined, thenHandler);

};

export function unlockCierreSemanal(centro_id, date) {

    return postData(`CierreSemanalDatos/DesbloquearCierre?centro_id=${centro_id}&date=${date}`, DESBLOQUEAR_CIERRE_SEMANAL, { }, undefined, undefined);

};

export function cerrarSemana(centro_id, date, observaciones, thenHandler, errorHandler) {

    return postData(`CierreSemanalDatos/CerrarSemana?centro_id=${centro_id}&date=${date}`, CIERRE_SEMANAL_CERRAR_SEMANA, { observacionesXdescuadre: observaciones }, undefined, thenHandler, true, errorHandler);
}